// Convierte un color hexadecimal a un array RGBA
export function hexToRgba(hex) {
  if (!hex) return [255, 0, 0, 0.5]

  hex = hex.replace('#', '')

  let r = 0
  let g = 0
  let b = 0
  let a = 1

  if (hex.length === 8) { // #RRGGBBAA
    r = parseInt(hex.slice(0, 2), 16)
    g = parseInt(hex.slice(2, 4), 16)
    b = parseInt(hex.slice(4, 6), 16)
    a = parseInt(hex.slice(6, 8), 16) / 255
  } else if (hex.length === 6) { // #RRGGBB
    r = parseInt(hex.slice(0, 2), 16)
    g = parseInt(hex.slice(2, 4), 16)
    b = parseInt(hex.slice(4, 6), 16)
    a = 1
  }

  return [r, g, b, a]
}
